export default __webpack_public_path__ + "static/media/mainImgOld.3ace51f9.png";